import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { LoginForm } from './Form';

// Styles
const s = require('./Login.css');

// Props
import { IApp } from 'stores/AllStores';

// Component
@inject('store')
@observer
export class Login extends React.Component<IApp, {}> {
  constructor(props: IApp) {
    super(props);
  }

  public render() {
    return (
      <div className={s.container}>
        <LoginForm
          headline="Welcome to Spyka CRM. Login with your credentials."
          location={this.props.location}
          history={this.props.history}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/user/login/Login.tsx